import React from "react";
import { Link as ScrollLink } from "react-scroll";
import moment from "moment";

const diff = moment().diff(moment("2016-04-05"), "years");

const aboutData = {
  cvpath: "media/Lucas-cv.pdf",
  image: "images/profile-2.jpeg",
  name: "Lucas Spirandeli",
  location: "Uberlandia, Brazil",
  birthday: "April, 1997",
  email: "lucasspi@outlook.com",
  aboutMe: `I'm a Computer Engineer with more than ${diff} years of experience working both as a <strong>Front-end</strong> and as a Full-stack Engineer. Proficient in many techs such as <strong>React-native, React</strong>, Typescript, JavaScript, <strong>NodeJs</strong>, Postgres, NoSQL and obviously HTML & CSS. I have great experience creating application entirely divided into reusable components. <br/><br/> In the last years <strong>I have read over 300 books</strong> on personal growth, leadership, emotional intelligence and business. Which makes me strong on Soft skills as well.`,
};

function About() {
  return (
    <div className="row">
      <div className="col-md-3 img-profile-about">
        <img
          src={aboutData.image}
          alt={aboutData.name}
          className="img-profile-about"
        />
      </div>
      <div className="col-md-9">
        <h2 className="mt-4 mt-md-0 mb-4">Hello,</h2>
        <p
          className="mb-0"
          dangerouslySetInnerHTML={{ __html: aboutData.aboutMe }}
        />
        <div className="row my-4">
          <div className="col-md-6">
            <p className="mb-2">
              Name: <span className="text-dark">{aboutData.name}</span>
            </p>
            <p className="mb-0">
              Birthday: <span className="text-dark">{aboutData.birthday}</span>
            </p>
          </div>
          <div className="col-md-6 mt-2 mt-md-0 mt-sm-2">
            <p className="mb-2">
              Location: <span className="text-dark">{aboutData.location}</span>
            </p>
            <p className="mb-0">
              Email: <span className="text-dark">{aboutData.email}</span>
            </p>
          </div>
        </div>
        <a
          href={aboutData.cvpath}
          target="_blank"
          className="btn btn-default mr-3"
          rel="noreferrer"
        >
          <i className="icon-cloud-download"></i>Download CV
        </a>
        <ScrollLink
          activeClass="active"
          to="section-contact"
          spy={true}
          smooth={true}
          duration={500}
          offset={50}
          className="btn btn-alt mt-2 mt-md-0 mt-xs-2"
        >
          <i className="icon-envelope"></i>Hire me
        </ScrollLink>
      </div>
    </div>
  );
}

export default About;
